<template lang="pug">
  .component-packet(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        card-n(:showBullets="true", :showAction="true", :columns="8")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              packet-buttons(:item="item", @itemUpdated="$emit('itemUpdated')")
          .field-value(slot="n1") P{{item.id}}
          .label(slot="n2") Name
          .field-value(slot="n2") {{item.name}}
          .label(slot="n3") Amount
          .field-value(slot="n3") {{item.amount}}
          .label(slot="n4") Minutes
          .field-value(slot="n4") {{item.minutes}}
          .label(slot="n5") Distance
          .field-value(slot="n5") {{item.distance}}
          .label(slot="n6") Duration
          .field-value(slot="n6") {{item.duration}}
          .label(slot="n7") Max Uses
          .field-value(slot="n7") {{item.max_uses}}
          .label(slot="n8") Status
          .field-value(slot="n8") {{item.status}}

</template>

<script>
import CardN from "../structure/CardN";
import PacketModal from "../structure/ui/actions/reveal/CreatePacketReveal.vue";
import Dropdown from "../structure/foundation/Dropdown";
import PacketButtons from "../structure/ui/actions/PacketButtons";
export default {
  name: "Packet",
  components: {PacketButtons, PacketModal, CardN, Dropdown},
  data() {
    return {}
  },
  created() {
  },
  methods: {},
  computed: {},
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Packet.vue?06e5692a